import { render } from "./ChatbotButton.vue?vue&type=template&id=4a34141f&scoped=true"
import script from "./ChatbotButton.vue?vue&type=script&lang=js"
export * from "./ChatbotButton.vue?vue&type=script&lang=js"

import "./ChatbotButton.vue?vue&type=style&index=0&id=4a34141f&scoped=true&lang=scss"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a34141f"]])

export default __exports__